export const placesApiKey = "AIzaSyACxjPit-CJM0oZwCcruPylaroMDSSg7CM";
export const placesBaseUrl = "https://maps.googleapis.com/maps/api/js";